
const footerContent = {
    copyright: "© 2026. All rights reserved.",
    links: [
      { href: "/my-impressum", label: "Impressum" },
      { href: "/my-datenschutz", label: "Datenschutz" },
    ]
  };
  
  export default footerContent;
  